import { ContainerInterface, ContainerParams, ContainerTypes, PARENT_TYPES, ROOT_TYPES, SourceTypes, Status } from "@/types/containerTypes";

export class Container implements ContainerInterface {
  id: string;
  position: number;
  createdAt: Date;
  updatedAt: Date;
  parentId: string;
  title: string;
  containerType: ContainerTypes;
  isScaffold: boolean;
  sourceId: string;
  sourceType?: SourceTypes;
  status: Status;
  description: string;
  rangeParameterId: string;
  skipParameterId: string;
  skipKeyId: string;
  rootId: string;
  rootType: ROOT_TYPES;
  parentType: PARENT_TYPES;
  conditionalFieldId: string;
  type: ContainerTypes;
  propelOrgId: string;

  constructor(params: ContainerParams) {
    this.id = params.id;
    this.updatedAt = params.updatedAt ? new Date(params.updatedAt) : new Date();
    this.createdAt = new Date(params.createdAt || this.updatedAt);
    this.parentId = params.parentId;
    this.position = params.position || 0;
    this.title = params.title || '';
    this.containerType = params.containerType;
    this.type = params.containerType;
    this.sourceId = params.sourceId || '';
    this.sourceType = params.sourceType;
    this.status = params.status || Status.PENDING;
    this.description = params.description || '';
    this.rangeParameterId = params.rangeParameterId || '';
    this.skipParameterId = params.skipParameterId || '';
    this.skipKeyId = params.skipKeyId || '';
    this.rootId = params.rootId;
    this.rootType = params.rootType;
    this.parentType = params.parentType;
    this.conditionalFieldId = params.conditionalFieldId || '';
    this.isScaffold = params.isScaffold;
    this.propelOrgId = params.propelOrgId || '';
  }

  isStep() {
    return this.containerType === ContainerTypes.Step;
  }

  isSection() {
    return this.containerType === ContainerTypes.Section;
  }

  isScenario() {
    return this.containerType === ContainerTypes.Scenario;
  }

  isRepeatingStep() {
    return this.containerType === ContainerTypes.RepeatingStep;
  }

  isRepeatingStepChild() {
    return this.containerType === ContainerTypes.RepeatingStepChild;
  }

  isFunctionCall() {
    return this.containerType === ContainerTypes.FunctionCall;
  }
}
